import React, { useEffect, useState } from 'react';
import './FloatingBackground.css';

const imageFiles = [
  '20240504_172550.jpg',
  '20240615_184316.jpg',
  '20241229_140644.jpg',
  'imagesasa.jpeg',
  'IMG-20240915-WA0053.jpg',
  'IMG-20250615-WA0007.jpg',
  'IMG_20251102_142415_549.jpg',
  'IMG_20251102_192613.jpg',
  'n_1afbd0123db286346ee656c8f0c290978dfb7400_661289eec1e180aa020bf3f664ee7dff07659dd8.jpg',
  'n_552067594a03c6da58df1bfae60ed2f268a94167_5774a4ef1a70b0b0cceb4c57be0843c905d1b65d.jpg',
  'n_99524e84ea60c4715db0c105c58829dd35afd742_1faae1e3c993ee434ce57b2657c523e0d79a5007.jpg',
  'n_995eca2e431cf9862c9d291e106d44d41c2c3582_aa5fe26071ca5aefa4eff356870b7cd3559fd602.jpg',
  'n_a906660523d6896ba3d51d9b64a422d53d437cc3_f2965d993ad9e4e992e57393a8930337d05e5ba3.jpg',
  'n_a906f5516941ad8ab87fec32f2beac47863ec649_00da5bc9cda9ae1cfa48e76b2fc71b9113d783e7.jpg',
  'n_a9081a428580143b3838059d29758bfb56d10ddf_36138fd9e8b7436fa1909971e9f0a902f94238b9.jpg',
  'n_be1a2eda207bfaedcb5b2413578c19abff698b7e_50a5f531d5e92312dabb4cbad17e193e5b7c17ba.jpg',
  'n_d35d4728e31d577d98cdf83eb0067a48e0f12915_e2e9e3f5b339893c40541685994b452fbf361bb3.jpg',
  'p_30713e2cfb7cfe81097d0dd5be3678c631eca608_36e01dead22d233ff74d9b9ca636f549fa65f9f9_v13.jpg',
];

const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

function FloatingBackground() {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    // Shuffle images and pick unique ones for each particle
    const shuffledImages = shuffleArray(imageFiles);
    const numParticles = 8;
    
    const initialParticles = Array.from({ length: numParticles }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 15 + 85,
      scale: Math.random() * 0.3 + 0.1,
      opacity: Math.random() * 0.5 + 0.2,
      duration: Math.random() * 8 + 12,
      delay: i * 1,
      size: Math.random() * 60 + 50,
      imageUrl: `/img/${shuffledImages[i % shuffledImages.length]}`,
    }));
    setParticles(initialParticles);
  }, []);

  return (
    <div className="floating-background">
      {particles.map((particle) => (
        <div
          key={particle.id}
          className="floating-particle"
          style={{
            '--delay': `${particle.delay}s`,
            '--duration': `${particle.duration}s`,
            '--start-x': `${particle.x}%`,
            '--start-y': `${particle.y}%`,
            '--size': `${particle.size}px`,
          }}
        >
          <img
            src={particle.imageUrl}
            alt="floating"
            className="particle-image"
          />
        </div>
      ))}
    </div>
  );
}

export default FloatingBackground;
